import React from "react";
import Dialog from "./dialog/Dialog";
import MaintenancePage from "./MaintenancePage";
import { useDispatch, useSelector } from "react-redux";
import { setMaintenanceModalOpen } from "../redux/actions";
import "../assets/maintenance.scss";

function MaintenanceModalCommon({ isFromBrowser }) {
  const dispatch = useDispatch();
  const maintenanceModalOpen = useSelector(
    (state) => state.common.maintenanceModalOpen
  );

  const handleMaintenanceModalClose = () => {
    dispatch(setMaintenanceModalOpen(false));
  };

  return (
    <Dialog
      isOpenModal={maintenanceModalOpen}
      setIsOpenModal={handleMaintenanceModalClose}
      directionToOpen={"up"}
      handleAction={() => handleMaintenanceModalClose()}
      isShowCloseIcon={true}
    >
      <MaintenancePage
        isUpcomingMaintenance={true}
        isFromBrowser={isFromBrowser}
        customClass={
          isFromBrowser
            ? "maintenance-options-wrapper"
            : "maintenance-popup-wrapper"
        }
      />
    </Dialog>
  );
}

export default MaintenanceModalCommon;
